module.exports = __webpack_public_path__ + "img/digest_main_image.1eaf3bf3.svg";